
export default function Loader() {
    return <i className="fa-solid fa-spinner fa-spin loading-spinner" aria-hidden="true"></i>;
}
